import React,{useState} from "react";

export default function ContactMe(){
  
   return (
    <div id="Contact" className="mt-4 w-full h-full flex flex-col items-center justify-center bg-blue-50 contact--section">
      <div>        
        <h2>Contact Me</h2>   
        <p>Email:estherwanjiqu@gmail.com</p>   
        <p>Contact: +254759400538</p>  
      </div>      
      <form className="w-full h-full flex flex-col items-center justify-center" action={`https://formsubmit.co/estherwanjiqu@gmail.com`} method="POST">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 w-full  lg:w-[80%] flex items-center justify-center h-full space-x-4">
          <div className="w-full h-full flex flex-col">
            <label htmlFor="name" className="contact--label">
            <span className="text-md">Name</span>
            <input
              type="text"
              className="contact--input text-md"
              name="name"
              id="name"
              required
              placeholder="Enter your name"
            />
          </label>
          </div>
          <div className="w-[90%]  h-full flex flex-col items-center justify-center">
            <label htmlFor="email" className="contact--label">
            <span className="text-md">Email</span>
            <input
              type="email"
              className="contact--input text-md"
              name="email"
              id="email"
              required
              placeholder="Enter your email"
            />
          </label>
          </div>          
         
        </div>
        <div className=" w-[90%] sm:w-[90%] md:w-[80%] lg:w-[70%] h-full flex flex-col">
             <label htmlFor="subject" className="contact--label">
            <span className="text-md">Subject</span>
            <input
              type="text"
              className="contact--input text-md"
              name="subject"
              id="subject"
              required
              placeholder="Type your subject"
            />
          </label>   
          </div> 
       
        <div className=" w-full h-full sm:w-[90%] md:w-[80%] lg:w-[70%] ">
            <label htmlFor="message" className="contact--label">
          <span className="text-md">Message</span>
          <textarea
            className="contact--input text-md flex items-center justify-center"
            id="message"
            rows="8"
            placeholder="Type your message..."
            required
            name="message"
          />
        </label>
        </div>

        <div className=" mt-4 w-full h-full sm:w-[90%] md:w-[80%] lg:w-[70%]">
          <button className="w-full h-12 rounded-lg bg-blue-500" type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
}

// import React, { useRef } from 'react';
// import emailjs from '@emailjs/browser';

// export default function ContactMe() {
//   const form = useRef();

//   const sendEmail = (e) => {
//     e.preventDefault();

//     emailjs
//       .sendForm(`${process.env?.GMAIL_SERVICE_ID}`, `${process.env?.MAIL_TEMPLATE_ID}`, form.current, {
//         publicKey: `${process.env?.GMAIL_ACCOUNT_PUBLIC_KEY}`,
//       })
//       .then(
//         () => {
//           console.log('SUCCESS!');
//         },
//         (error) => {
//           console.log('FAILED...', error.text);
//         },
//       );
//   };

//   return (
//     <form ref={form} onSubmit={sendEmail} id='Contact'>
//       <label>Name</label>
//       <input type="text" name="from_name" />
//       <label>Email</label>
//       <input type="email" name="from_email" />
//       <label>Message</label>
//       <textarea name="message" />
//       <input type="submit" value="Send" />
//     </form>
//   );
// };
